
    import { imgResize } from '@/utils/helpers';

    export default {
        name: 'CompanyLogo',

        props: {
            logo: {
                type: String,
                default: '',
            },

            companyName: {
                type: String,
                default: '',
            },

            companyLink: {
                type: String,
                default: '',
            },

            noShadow: {
                type: Boolean,
                default: false,
            },

            size: {
                type: String,
                default: '',
            },

            type: {
                type: String,
                default: 'square',
            },

            lazyLoad: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {};
        },

        computed: {
            classList() {
                return [
                    'company-logo',
                    this.getNoShadowClass,
                    this.getSizeClass,
                    this.getTypeClass,
                    this.getIsLogoClass,
                ];
            },

            getIsLogoClass() {
                return this.logo ? 'is-logo' : '';
            },

            getNoShadowClass() {
                return this.noShadow ? 'no-shadow border border-light-600' : '';
            },

            getSizeClass() {
                if (!this.logo && this.isTypeRectangle) {
                    return '';
                }

                return this.size ? `is-${this.size}` : '';
            },

            getTypeClass() {
                if (!this.logo) {
                    return 'is-square';
                }

                return this.type ? `is-${this.type}` : '';
            },

            companyNameFirstLetter() {
                return this.companyName.charAt(0).toUpperCase() || 'P';
            },

            logoUrl() {
                let w = this.isTypeRectangle ? 100 : 80;
                let h = this.isTypeRectangle ? 40 : 80;

                if (this.size === 'sm') {
                    w = this.isTypeRectangle ? 70 : 60;
                    h = this.isTypeRectangle ? 30 : 60;
                } else if (this.size === 'lg') {
                    w = this.isTypeRectangle ? 150 : 120;
                    h = this.isTypeRectangle ? 80 : 120;
                }
                return imgResize(this.logo, w, h, 100);
            },

            isTypeRectangle() {
                return this.type === 'rectangle';
            },
        },

        methods: {},
    };
